import * as React from 'react';
import {keyCodes} from '../../../constants';

interface withKeysProps {
    onEnterKeyDown?: (event) => void;
    onEscKeyDown?: (event) => void;
}

export const withKeys = <P extends object>(InnerComponent: React.ComponentType<P>) => {
    return class extends React.Component<P & withKeysProps, null> {
        constructor(props) {
            super(props);
            this.handleKeyDown = this.handleKeyDown.bind(this);
        }

        componentDidMount() {
            window.addEventListener('keydown', this.handleKeyDown, true);
        }

        componentWillUnmount() {
            window.removeEventListener('keydown', this.handleKeyDown, true);
        }

        handleKeyDown = e => {
            e.stopPropagation();
            switch (e.keyCode) {
                case keyCodes.ENTER:
                    this.props.onEnterKeyDown(e);
                    break;
                case keyCodes.ESC:
                    this.props.onEscKeyDown(e);
                    break;
                default:
                    break;
            }
        };

        render() {
            return <InnerComponent {...this.props} />;
        }
    };
};
